export default {
  edit: "filterTaxonomy:rule:edit",
  create: "filterTaxonomy:rule:create",
  delete: "filterTaxonomy:rule:delete",
  view: "filterTaxonomy:rule:view",
};
